// SidebarCollapsibleSection.js

import React from "react";
import { ListItemButton, ListItemIcon, ListItemText, Collapse, Box } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

// Import modern sidebar typography styles
import './SidebarTypography.css';

const SidebarCollapsibleSection = ({
  title,
  icon,
  open,
  isSectionOpen,
  setIsSectionOpen,
  children,
  rightIcon,
  hasChildren = true,
  isHighlighted = false,
  compact = false,
}) => {
  const headerFontSize = compact ? "14px" : "16px";
  const minHeight = compact ? 36 : 44;

  return (
    <>
      <ListItemButton
        onClick={() => setIsSectionOpen((prev) => !prev)}
        className="sidebar-typography"
        sx={{
          minHeight,
          justifyContent: open ? "initial" : "center",
          px: open ? (compact ? 2 : 3) : 2,
          mx: 0,
          borderRadius: "8px",
          background: "transparent",
          border: "1px solid transparent",
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          "&:hover": {
            background: "rgba(99,102,241,0.08)",
            borderColor: "rgba(99,102,241,0.2)",
          },
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          mb: 0.5,
        }}
      >
            <ListItemIcon
          sx={{
            minWidth: open ? "20px" : "0px",
            justifyContent: "center",
            marginRight: open ? (compact ? "8px" : "10px") : "0px",
            color: "rgba(71,85,105,0.7)",
            transition: 'min-width 0.3s cubic-bezier(0.4, 0, 0.2, 1), margin-right 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          {icon}
        </ListItemIcon>
        {open && (
          <>
            <ListItemText
              disableTypography
              primary={title}
              className="sidebar-typography sidebar-nav-item"
              sx={{
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
                pr: 0.5,
                fontSize: headerFontSize,
                fontWeight: 500,
                color: "rgba(30,41,59,0.8)",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                opacity: open ? 1 : 0,
                transition: 'opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            />
            <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 0, flexShrink: 0 }}>
              {rightIcon}
              {hasChildren && (
                <Box component="span" sx={{ ml: 0.25 }}>
                  {isSectionOpen ? 
                    <ExpandLess sx={{ color: "rgba(99,102,241,0.7)", fontSize: 18 }} /> : 
                    <ExpandMore sx={{ color: "rgba(71,85,105,0.6)", fontSize: 18 }} />
                  }
                </Box>
              )}
            </Box>
          </>
        )}
      </ListItemButton>

      <Collapse in={isSectionOpen && open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  );
};

export default SidebarCollapsibleSection;
